import { createSlice, createAsyncThunk } from '@reduxjs/toolkit';
import { placebid } from '../../Apis/index';

export const PlaceBid = createAsyncThunk('placebid', async ({ formData, token }, { rejectWithValue }) => {
    try {
        const response = await placebid({ formData, token });
        return response;
    } catch (error) {
        return rejectWithValue(error.response);
    }
});

const placebidSlice = createSlice({
    name: 'placeBid',
    initialState: {
        error: null,
        success: false,
        loading: false,
    },
    reducers: {
        clearplacebidStatus: state => {
            state.success = false;
            state.error = null;
            state.loading = false;
        },
    },
    extraReducers: builder => {
        builder
            .addCase(PlaceBid.pending, state => {
                state.error = null;
                state.success = false;
                state.loading = true;
            })
            .addCase(PlaceBid.fulfilled, (state, action) => {
                state.success = action.payload;
                state.error = null;
                state.data = action.payload.data.data;
                state.loading = false;
            })
            .addCase(PlaceBid.rejected, (state, action) => {
                state.error = action.payload;
                state.success = false;
                state.loading = false;
            })
    },

});
export const { clearplacebidStatus } = placebidSlice.actions;
export default placebidSlice.reducer;

